import React from 'react'
import PropTypes from 'prop-types'
import { Spacing50 } from 'styles/sharedStyle'
import {
  Desc,
  Headline,
  Inner,
  Item,
  ItemHeadline,
  List,
  Wrapper,
  QR,
} from './Steps.style'

const Steps = ({ headline, items, qr }) => (
  <Wrapper>
    <Spacing50 />
    <Inner>
      <Headline>{headline}</Headline>
      {!!qr && <QR {...qr} />}
      {!!items.length && (
        <List count={items.length}>
          {items.map((item, i) => (
            <Item key={`step_${i.toString()}`}>
              {!!item.headline && <ItemHeadline>{item.headline}</ItemHeadline>}
              {!!item.description && (
                <Desc
                  dangerouslySetInnerHTML={{
                    __html: item.description.description.replace(
                      /\n/g,
                      '<br> '
                    ),
                  }}
                />
              )}
            </Item>
          ))}
        </List>
      )}
    </Inner>
    <Spacing50 />
  </Wrapper>
)

Steps.propTypes = {
  headline: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      headline: PropTypes.string,
      description: PropTypes.shape({
        description: PropTypes.string,
      }),
    })
  ),
  qr: PropTypes.shape({
    alt: PropTypes.string,
    src: PropTypes.string,
  }),
}

Steps.defaultProps = {
  items: [],
  qr: null,
}

export default Steps
